import React from 'react';
import jQuery from "jquery";
import * as XLSX from 'xlsx';
import Highcharts from 'highcharts';

import Configurator from './Configurator.jsx';
import styles from './SelectivityConfigurator.styl';
import Button from './ui/button/Button.jsx';
import Image from "./ui/features/Image.jsx";
import Popup from "./ui/features/Popup/Popup.jsx";


/**
 * Калькулятор селективности
 */


class SelectivityConfigurator extends Configurator {

	constructor(props) {
		super(props);

		this.state = {
			configurators: {
				highSwitch: [
					{
						name: 'Подбор селективного устройства для',
						option: ['вышестоящего'],
						disabled: false,
						selected: 'вышестоящего',
						show: false,
					},
					{
						name: 'Тип аппарата',
						option: ['модульный', 'силовой', 'предохранитель'],
						disabled: false,
						selected: null,
						show: true,
					},
					{
						name: 'Типоисполнение аппарата',
						option: [],
						disabled: true,
						selected: null,
						show: true,
					},
					{
						name: 'Номинальный ток, А',
						option: [],
						disabled: true,
						selected: null,
						show: true,
					},
					{
						name: 'Число полюсов',
						option: [],
						disabled: true,
						selected: null,
						show: true,
					},
					{
						name: 'Тип кривой срабатывания',
						option: [],
						disabled: true,
						selected: null,
						show: true,
					},
					{
						name: 'Номинальный ток расцепителя, А',
						option: [],
						disabled: true,
						selected: null,
						show: true,
					},
					{
						name: 'Отключающая способность (кА)',
						option: [],
						disabled: true,
						selected: null,
						show: true,
					},
					{
						name: 'Пердельная отк-я способность (кА)',
						option: [],
						disabled: true,
						selected: null,
						show: false,
					}
				],
				lowSwitch: [
					{
						name: 'Уставка защиты по току перегрузки «Ir»',
						option: [0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 0.95, 1],
						disabled: false,
						selected: null,
						show: true,
					},
					{
						name: 'Уставка защиты по времени перегрузки «Tr»',
						option: ['без защиты', 12, 60, 80, 100],
						disabled: true,
						selected: null,
						show: true,
					},
					{
						name: 'Уставка защиты от КЗ по току «Isd»',
						option: [2, 2.5, 3, 4, 5, 6, 7, 8, 10, 12],
						disabled: true,
						selected: null,
						show: true,
					},
					{
						name: 'Уставка защиты от КЗ по времени «Tsd»',
						option: ['без защиты', 0.06, 0.1, 0.2, 0.3],
						disabled: true,
						selected: null,
						show: true,
					},
					{
						name: 'Уставка по току защиты от КЗ мгновенного срабатывания «Ii»',
						option: ['без защиты', 4, 6, 7, 8, 10, 11, 12, 13, 14],
						disabled: true,
						selected: null,
						show: true,
					},
					{
						name: 'Уставка электромагнитного расцепителя «Im»',
						option: [1.5, 2, 4, 6, 8, 10, 12],
						disabled: false,
						selected: null,
						show: false,
					},
					{
						name: 'Кривая срабатывания',
						option: [3, 6, 12, 18],
						disabled: true,
						selected: null,
						show: false,
					}
				],

			},
			checkboxes: {
				checkbox1: false, // показать снятые с производства - да / нет
			},
			buttons: {
				button1: false,
				button2: false,
				button3: false,
				button4: false,
				button5: false,
			},
			engine: [{y: 0.0001, x: 0.0001}, {y: 0, x: 0}, {y: 0, x: 0}, {y: 0, x: 0}, {y: 7200, x: 0}],
			data: [],
			fileName: 'Выбрать файл',
			setLowSwitch: [],
			setHighSwitch: [],
			selectivityTable: [],
			forPrint: [],
			deviceForSelectivityTable: [],
			inputFilter: {
				value: '',
				filterDeviceTable: []
			},
			itemInfo: null,
			graphs: [],
			changibleIndex: null,
			warningText: ''
		};
		this.onSwitchConfigurator = this.onSwitchConfigurator.bind(this);
		this.Chart = this.Chart.bind(this);
		this.ChangeCheckbox = this.ChangeCheckbox.bind(this);
		this.changeConfigurator = this.changeConfigurator.bind(this);
		this.onBtnCalculate = this.onBtnCalculate.bind(this);
		this.clearAll = this.clearAll.bind(this);
		this.onBtnAddSwitch = this.onBtnAddSwitch.bind(this);
		this.onBtnExcelClick = this.onBtnExcelClick.bind(this);
		this.delDuplicatesFromArray = this.delDuplicatesFromArray.bind(this);
		this.highSwitcherChoosen = this.highSwitcherChoosen.bind(this);
		this.onRowClick = this.onRowClick.bind(this);
		this.addInfo = this.addInfo.bind(this);
		this.getGraph = this.getGraph.bind(this);
		this.drowChart = this.drowChart.bind(this);
		this.getCurrentItem = this.getCurrentItem.bind(this);
		this.getColorArray = this.getColorArray.bind(this);
		this.getGraphPoints = this.getGraphPoints.bind(this);
		this.fillingCheck = this.fillingCheck.bind(this);
		this.onBtnClick1 = this.onBtnClick1.bind(this)
		this.onBtnClick2 = this.onBtnClick2.bind(this)
		this.onBtnClick3 = this.onBtnClick3.bind(this)
		this.onBtnClick4 = this.onBtnClick4.bind(this)
		this.onResetFilter = this.onResetFilter.bind(this)
		this.readExelFile = this.readExelFile.bind(this)
		this.onBtnLoadGraphDataExel = this.onBtnLoadGraphDataExel.bind(this)
		this.onXLSDownload = this.onXLSDownload.bind(this)
		this.onLoadGraphDataCurrentKZ = this.onLoadGraphDataCurrentKZ.bind(this)
		this.readEngineData = this.readEngineData.bind(this)
		this.onLoadGraphDataEngine = this.onLoadGraphDataEngine.bind(this)
		this.clearEngineData = this.clearEngineData.bind(this)
	}

	//тип конфигуратора
	getType() {
		return 'selectivity';
	}

	//загрузка бд и первоначальная отрисовка графика
	componentDidMount() {

		this.loadDb()
		this.drowChart()
	}

	//загрузка БД
	loadDb() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db = db;
			}
		);
	}

	//скачивание шаблона excel файла
	onXLSDownload() {
		window.location = `itkcfg.php?type=selectivity&action=getFile&name=iek-time-current-file.xlsx`;
	}
	showWarning(warningText){
		this.setState({
			warningText
		}, ()=>{
			document.location.href = document.location.href.split('#')[0] + '#warning'
		})
	}

	clickAwayHandler(event){
		if(event.target.id && event.target.id === 'warning'){
			this.closeWarning()
		}
	}

	closeWarning(){
		document.location.href = document.location.href.split('#')[0] + '#'
	}

	// измененине чекбокса
	ChangeCheckbox() {

		const configurators = this.state.configurators;

		for (let key in configurators) {
			for (let i = 1; i < configurators[key].length; i++) {
				configurators[key][i].option = [];
				configurators[key][i].disabled = true;
				configurators[key][i].selected = null;
				if (i === 1) {
					configurators[key][i].option = ['модульный', 'силовой', 'предохранитель'];
					configurators[key][i].disabled = false;
				}
			}
		}

		this.setState(prev => {
			return {checkboxes: {...prev.checkboxes, checkbox1: !prev.checkboxes.checkbox1}, configurators};
		})
	}

	// Таблица селективности оборудования
	selectivityTable(selectivity) {

		const customStyles = this.getCustomStyles();
		return <tbody className={selectivity.length > 5 ? customStyles.tableScroll : customStyles.tableNotScroll}>
		{selectivity.map((item, index) => {
			return <tr key={index} onClick={() => item.selectivity !== undefined ? this.onRowClick(item) : null}>
				<td>
					<div className={customStyles.graphColor} style={{backgroundColor: item.color}}/>
					<div>{item.firstCol}</div>
				</td>
				<td>{item.secondCol}</td>
				<td>{item.threeCol}</td>
				<td>{item.forCol} А</td>
				<td>{item.fiveCol} А</td>
				<td>{index === 0 ? 'Нет вышестоящего выключателя'
					: this.state.selectivitySC1 ? this.state.selectivitySC1[index - 1][0] : '-'}</td>
				<td>{index === 0 ? 'Нет вышестоящего выключателя'
					: this.state.selectivitySC2 ? this.state.selectivitySC2[index - 1][0] : '-'}</td>
				<td>{index === 0 ? '-'
					: this.state.selectivitySC1[index - 1][1]}</td>
				<td>{index === 0 ? '-'
					: this.state.selectivitySC2[index - 1][1]}</td>
			</tr>
		})}
		</tbody>
	}

	// кнопки
	getCustomElements() {
		let elements = [];
		if (this.state.buttons.button1) {
			elements.push(
				<Button
					x="135"
					y="413"
					buttonStyle={styles.buttonAddSwitch}
					textStyle={styles.mainBtnText}
					iconStyle={styles.buttonAddSwitchIcon}
					text={this.state.configurators.highSwitch[5].selected == 'Электронный' && !this.state.buttons.button5 ? 'Далее' : 'Добавить выключатель'}
					onClick={this.onBtnAddSwitch}
					key="addswitch"
				/>
			);
		}
		if (!this.state.buttons.button1 && !this.state.buttons.button2) {
			elements.push(
				<Button
					x="20"
					y="180"
					buttonStyle={styles.buttonFindSelectivity}
					textStyle={styles.mainBtnTextBig}
					iconStyle={styles.buttonFindSelectivityIcon}
					text="Выбрать устройство из каталога"
					onClick={this.onBtnClick1}
					key="findSelectivity"
				/>)
			// elements.push(
			// 	<Button
			// 		x="20"
			// 		y="280"
			// 		buttonStyle={styles.buttonLoadGraphData}
			// 		textStyle={styles.mainBtnTextBig}
			// 		iconStyle={styles.buttonLoadGraphDataIcon}
			// 		text="Загрузить ВТХ устройства"
			// 		onClick={this.onBtnClick2}
			// 		key="loadGraphData"
			// 	/>)

		}
		if (this.state.buttons.button3) {
			elements.push(
				<Button
					x="135"
					y="413"
					buttonStyle={styles.buttonAddSwitch}
					textStyle={styles.mainBtnText}
					iconStyle={styles.buttonAddSwitchIcon}
					text="Добавить график"
					onClick={this.onBtnLoadGraphDataExel}
					key="onBtnLoadGraphDataMnl"
				/>
			);
		}
		if (this.state.buttons.button4) {
			elements.push(
				<Button
					x="78"
					y="280"
					buttonStyle={styles.buttonAddSwitch}
					textStyle={styles.mainBtnText}
					iconStyle={styles.buttonAddSwitchIcon}
					text="Добавить график"
					onClick={this.onBtnLoadGraphDataExel}
					disabled={this.state.fileName === 'Выбрать файл'}
					key="onBtnLoadGraphDataExel"
				/>
			);
		}
		if (!this.state.buttons.button1 && this.state.buttons.button2 && !this.state.buttons.button3 && !this.state.buttons.button4) {
			elements.push(
				<Button
					x="20"
					y="180"
					buttonStyle={styles.buttonLoadGraphData}
					textStyle={styles.mainBtnTextBig}
					iconStyle={styles.buttonLoadGraphDataMnlIcon}
					text="Ввести данные ВТХ вручную"
					onClick={this.onBtnClick3}
					key="loadGraphDataManual"
				/>)
			elements.push(
				<Button
					x="20"
					y="280"
					buttonStyle={styles.buttonLoadGraphData}
					textStyle={styles.mainBtnTextBig}
					iconStyle={styles.buttonLoadGraphDataExlIcon}
					text="Загрузить ВТХ из EXCEL-файла"
					onClick={this.onBtnClick4}
					key="loadGraphDataExcel"
				/>)

		}
		elements.push(
			<Button
				x="135"
				y="833"
				buttonStyle={styles.buttonAddSwitch}
				textStyle={styles.mainBtnText}
				iconStyle={styles.buttonAddSwitchIcon}
				text="Добавить график"
				onClick={this.onLoadGraphDataEngine}
				key="onBtnLoadGraphDataEngine"
			/>
		);
		elements.push(
			<Button
				x="20"
				y="833"
				buttonStyle={styles.buttonClearEngineData}
				textStyle={styles.mainBtnTextSmall}
				iconStyle={styles.buttonClearEngineDataIcon}
				text="Очистить"
				onClick={this.clearEngineData}
				key="clearEngineData"
			/>
		);

		elements.push(
			<Button
				x="56"
				y="1195"
				// buttonStyle={styles.buttonClearAll}
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.buttonClearAllIcon}
				text="Очистить таблицу"
				onClick={this.clearAll}
				key="clearAll"
			/>
		);


		elements.push(
			<Button
				x="315"
				y="1195"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);
		elements.push(
			<Button
				x="550"
				y="1195"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				onClick={this.onBtnPrintClick}
				key="print"
			/>
		);

		elements.push(
			<Button
				x="785"
				y="1195"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.excelBtnIcon}
				text="Сохранить в Excel"
				onClick={this.onBtnExcelClick}
				key="excel"
			/>
		);

		return elements;
	}

	onBtnClick1() {
		if (this.state.selectivityTable.length === 5) {
			return
		}
		this.setState(prev => {
			return {buttons: {...prev.buttons, button1: !prev.buttons.button1}}
		})
	}

	onBtnClick2() {
		if (this.state.selectivityTable.length === 5) {
			return
		}
		this.setState(prev => {
			return {buttons: {...prev.buttons, button2: !prev.buttons.button2}}
		})
	}

	onBtnClick3() {
		this.setState(prev => {
			return {buttons: {...prev.buttons, button3: !prev.buttons.button3}}
		})
	}

	onBtnClick4() {
		this.setState(prev => {
			return {buttons: {...prev.buttons, button4: !prev.buttons.button4}}
		})
	}

	//подготовка данных excel для отрисовки графика
	onBtnLoadGraphDataExel() {
		let exel = this.state.data.map(i => {
			return {y: i["Время, с."], x: i["Ток, А."]}
		})
		const selectivityTable = this.state.selectivityTable;
		if (this.state.changibleIndex !== null) {
			//Формирование имени графика
			let graphName = 'Аппарат защиты №' + (this.state.changibleIndex + 1)

			// запись всех полей
			const addSwitch = {
				bodySize: '-', // габарит корпуса
				name: '-', // тип продукции
				nominalCurrent: '-', // номинальный ток In,A
				numberPoles: '-', // число полюсов
				typeCurve: '-', // тип кривой
				releaseCurrent: '-', // ток расцепителя Isd, A
				breakingCapacity: '-', // отключающая способность кА
				maxBreakingCapacity: '-', // Для силового, отключающая способность
				graphName: graphName, // имя графика
				color: this.getColorArray()[this.state.changibleIndex], // цвет графика
				index: this.state.changibleIndex,
				graph: exel,
			};
			this.onBtnCalculate(addSwitch);
			this.getGraph(addSwitch);
		} else {
			//Формирование имени графика
			let graphName = 'Аппарат защиты №' + (selectivityTable.length + 1)

			// запись всех полей
			const addSwitch = {
				bodySize: '-', // габарит корпуса
				name: '-', // тип продукции
				nominalCurrent: '-', // номинальный ток In,A
				numberPoles: '-', // число полюсов
				typeCurve: '-', // тип кривой
				releaseCurrent: '-', // ток расцепителя Isd, A
				breakingCapacity: '-', // отключающая способность кА
				maxBreakingCapacity: '-', // Для силового, отключающая способность
				graphName: graphName, // имя графика
				color: this.getColorArray()[selectivityTable.length], // цвет графика
				graph: exel,
			};

			if (!this.highSwitcherChoosen()) {
				this.onBtnCalculate(addSwitch);
				this.getGraph(addSwitch)
				this.setState(prev => {
					return {
						data: [],
						buttons: {
							button1: false,
							button2: false,
							button3: false,
							button4: false,
							button5: false,
						},
						fileName: 'Выбрать файл',
						setHighSwitch: [...prev.setHighSwitch, addSwitch],
						changibleIndex: null
					}
				})
			} else {
				this.onBtnCalculate(addSwitch);
				this.getGraph(addSwitch)
				this.setState(prev => {
					return {
						data: [],
						buttons: {
							button1: false,
							button2: false,
							button3: false,
							button4: false,
							button5: false,
						},
						fileName: 'Выбрать файл',
						setLowSwitch: [...prev.setLowSwitch, addSwitch],
						changibleIndex: null
					}
				})
			}
		}
	}

	//очистить конфигурацию
	onResetFilter() {
		const configurator = [...this.state.configurators.highSwitch];
		// Очистка всех полей
		for (let i = 1; i < configurator.length; i++) {
			configurator[i].option = [];
			configurator[i].disabled = true;
			configurator[i].selected = null;
			if (i === 1) {
				configurator[i].option = ['модульный', 'силовой', 'предохранитель'];
				configurator[i].disabled = false;
			}
		}
		const configuratorLow = [...this.state.configurators.lowSwitch];
		for (let i = 0; i < configuratorLow.length; i++) {
			configuratorLow[i].disabled = true;
			configuratorLow[i].selected = null;
			if (i === 0 || i === 5) {
				configuratorLow[i].disabled = false;
			}
		}

		this.setState(prev => {
			return {
				data: [],
				buttons: {
					button1: false,
					button2: false,
					button3: false,
					button4: false
				},
				fileName: 'Выбрать файл',
				configurators: {...prev.configurators, highSwitch: configurator, lowSwitch: configuratorLow}
			}
		})
	}

	// Очищает таблицу селективности, удаляет графики
	clearAll() {

		// Настройки конфигуратора
		const configurator = [...this.state.configurators.highSwitch];
		// Очистка всех полей
		for (let i = 1; i < configurator.length; i++) {
			configurator[i].option = [];
			configurator[i].disabled = true;
			configurator[i].selected = null;
			if (i === 1) {
				configurator[i].option = ['модульный', 'силовой', 'предохранитель'];
				configurator[i].disabled = false;
			}
		}
		const configuratorLow = [...this.state.configurators.lowSwitch];
		for (let i = 0; i < configuratorLow.length; i++) {
			configuratorLow[i].disabled = true;
			configuratorLow[i].selected = null;
			if (i === 0 || i === 5) {
				configuratorLow[i].disabled = false;
			}
		}


		// Установить состояние
		this.setState(prev => {
			return {
				selectivityTable: [],
				setHighSwitch: [],
				setLowSwitch: [],
				configurators: {...prev.configurators, highSwitch: configurator, lowSwitch: configuratorLow},
				graphs: [],
				itemInfo: null,
				changibleIndex: null
			}
		});
		this.drowChart()

	}

	// добавления выключателя
	onBtnAddSwitch() {

		// настройки конфигуратора
		const configurator = [...this.state.configurators.highSwitch];
		const configuratorLow = [...this.state.configurators.lowSwitch]

		// если не все нужные поля заполненны
		if (!this.fillingCheck(configurator, 'selCountTable')) return;

		if (this.state.buttons.button5 && this.state.configurators.lowSwitch[4].selected !== null && this.state.configurators.lowSwitch[2].selected !== null && +this.state.configurators.lowSwitch[4].selected < +this.state.configurators.lowSwitch[2].selected) {
			return;
		}
		if (this.state.buttons.button5 && this.state.configurators.lowSwitch[3].selected !== null && this.state.configurators.lowSwitch[1].selected !== null) {
			let Ir = configuratorLow[0].selected * configurator[3].selected
			let Tr = configuratorLow[1].selected
			let Isd = configuratorLow[2].selected
			let Tsd = configuratorLow[3].selected
			let Ii = isNaN(configuratorLow[4].selected) ? 15 * Ir : configuratorLow[4].selected * Ir
			let Im = Ir * Isd
			let point1 = isNaN(Tr) ? Math.pow(2 * Ir, 2) * 12 / Math.pow(Im, 2) : Math.pow(2 * Ir, 2) * Tr / Math.pow(Im, 2)
			let point2 = isNaN(Tsd) ? 0.06 : Math.pow(1.5 * Im, 2) * Tsd / Math.pow(Im, 2)
			if (point2 > point1) {
				return;
			}
		}

		const selectivityTable = this.state.selectivityTable;
		if (this.state.changibleIndex !== null) {
			//Формирование имени графика
			let graphName = 'Аппарат защиты QF' + (this.state.changibleIndex + 1)

			// запись всех полей
			let addSwitch = {
				bodySize: configurator[1].selected, // габарит корпуса
				name: configurator[2].selected, // тип продукции
				nominalCurrent: configurator[3].selected, // номинальный ток In,A
				numberPoles: configurator[4].selected, // число полюсов
				typeCurve: configurator[5].selected, // тип кривой
				releaseCurrent: configurator[6].selected, // ток расцепителя Isd, A
				breakingCapacity: configurator[7].selected, // отключающая способность кА
				maxBreakingCapacity: configurator[8].selected, // Для силового, отключающая способность
				graphName: graphName, // имя графика
				color: this.getColorArray()[this.state.changibleIndex], // цвет графика
				index: this.state.changibleIndex
			};

			if (configurator[5].selected === 'Электронный' && !this.state.buttons.button5) {
				this.setState(prev => {
					return {buttons: {...prev.buttons, button5: true}}
				})
				return;
			}
			if (configurator[5].selected == "Электронный") {
				if (configurator[2].selected.includes('MASTER')) {
					if (configuratorLow.some((item, index) => {
						if (index > 4) {
							return
						}
						return item.selected == null
					})) {
						return
					}
					addSwitch = {
						...addSwitch,
						Ir: configuratorLow[0].selected,
						Tr: configuratorLow[1].selected,
						Isd: configuratorLow[2].selected,
						Tsd: configuratorLow[3].selected,
						Ii: configuratorLow[4].selected
					}
				} else {
					if (configuratorLow.some((item, index) => {
						if (index > 0 && index < 5) {
							return
						}
						return item.selected == null
					})) {
						return
					}
					addSwitch = {
						...addSwitch,
						Ir: configuratorLow[0].selected,
						Im: configuratorLow[5].selected,
						ICurve: configuratorLow[6].selected
					}
				}
			}

			for (let i = 1; i < configurator.length; i++) {
				configurator[i].option = [];
				configurator[i].disabled = true;
				configurator[i].selected = null;
				if (i === 1) {
					configurator[i].option = ['модульный', 'силовой', 'предохранитель'];
					configurator[i].disabled = false;
				}
			}
			for (let i = 0; i < configuratorLow.length; i++) {
				configuratorLow[i].disabled = true;
				configuratorLow[i].selected = null;
				if (i === 5 || i === 0) {
					configuratorLow[i].disabled = false;
				}
			}


			this.getGraph(addSwitch);
			this.onBtnCalculate(addSwitch);
			this.setState((prev) => {
				return {
					changibleIndex: null, buttons: {
						button1: false,
						button2: false,
						button3: false,
						button4: false,
						button5: false,
					}, configurators: {...prev.configurators, highSwitch: configurator}
				}
			})
		} else {
			//Формирование имени графика
			let graphName = 'Аппарат защиты QF' + (selectivityTable.length + 1)

			// запись всех полей
			let addSwitch = {
				bodySize: configurator[1].selected, // габарит корпуса
				name: configurator[2].selected, // тип продукции
				nominalCurrent: configurator[3].selected, // номинальный ток In,A
				numberPoles: configurator[4].selected, // 	число полюсов
				typeCurve: configurator[5].selected, // тип кривой
				releaseCurrent: configurator[6].selected, // ток расцепителя Isd, A
				breakingCapacity: configurator[7].selected, // отключающая способность кА
				maxBreakingCapacity: configurator[8].selected, // Для силового, отключающая способность
				graphName: graphName, // имя графика
				color: this.getColorArray()[selectivityTable.length], // цвет графика
			};
			if (configurator[5].selected === 'Электронный' && !this.state.buttons.button5) {
				this.setState(prev => {
					return {buttons: {...prev.buttons, button5: true}}
				})
				return;
			}
			if (configurator[5].selected == "Электронный") {
				if (configurator[2].selected.includes('MASTER')) {
					if (configuratorLow.some((item, index) => {
						if (index > 4) {
							return
						}
						return item.selected == null
					})) {
						return
					}
					addSwitch = {
						...addSwitch,
						Ir: configuratorLow[0].selected,
						Tr: configuratorLow[1].selected,
						Isd: configuratorLow[2].selected,
						Tsd: configuratorLow[3].selected,
						Ii: configuratorLow[4].selected
					}
				} else {
					if (configuratorLow.some((item, index) => {
						if (index > 0 && index < 5) {
							return
						}
						return item.selected == null
					})) {
						return
					}
					addSwitch = {
						...addSwitch,
						Ir: configuratorLow[0].selected,
						Im: configuratorLow[5].selected,
						ICurve: configuratorLow[6].selected
					}
				}
			}

			// очистка всех полей
			for (let i = 1; i < configurator.length; i++) {
				configurator[i].option = [];
				configurator[i].disabled = true;
				configurator[i].selected = null;
				if (i === 1) {
					configurator[i].option = ['модульный', 'силовой', 'предохранитель'];
					configurator[i].disabled = false;
				}
			}
			for (let i = 0; i < configuratorLow.length; i++) {
				configuratorLow[i].disabled = true;
				configuratorLow[i].selected = null;
				if (i === 5 || i === 0) {
					configuratorLow[i].disabled = false;
				}
			}


			// добавление в state
			if (!this.highSwitcherChoosen()) {
				this.getGraph(addSwitch)
				this.onBtnCalculate(addSwitch);
				this.setState(prev => {
					return {
						buttons: {
							button1: false,
							button2: false,
							button3: false,
							button4: false,
							button5: false,
						},
						setHighSwitch: [...prev.setHighSwitch, addSwitch],
						configurators: {...prev.configurators, highSwitch: configurator},
						changibleIndex: null
					}
				})
			} else {
				this.getGraph(addSwitch)
				this.onBtnCalculate(addSwitch);

				this.setState(prev => {
					return {
						buttons: {
							button1: false,
							button2: false,
							button3: false,
							button4: false,
							button5: false,
						},
						setLowSwitch: [...prev.setLowSwitch, addSwitch],
						configurators: {...prev.configurators, highSwitch: configurator},
						changibleIndex: null
					}
				})
			}
		}
	}

	fillingCheck(configurator, type) {

		if ((type === 'selCountTable')
			&& (!configurator[3].selected
				|| !configurator[6].selected)) {
			let element = document.getElementById('selWarn')
			element.classList.remove('selectivityWarningDisable')
			element.classList.add('selectivityWarningEnable')
			return false
		}

		return true
	}

	// посчитать селективность
	onBtnCalculate(item) {
		const selectivityTable = this.state.selectivityTable;
		if (this.state.changibleIndex !== null) {

			let config = {};
			config = item;
			const setLowSwitch = item;

			let newItem = {
				firstCol: item.graphName, // Имя графика
				secondCol: setLowSwitch.name, // тип продукции
				threeCol: setLowSwitch.typeCurve, // тип кривой
				forCol: setLowSwitch.releaseCurrent, // ток расцепителя
				fiveCol: setLowSwitch.nominalCurrent,  // In номинальный ток
				info: item, // Сохраняем данные фильтра
				forPrint: this.getCurrentItem(item), // Сохранение данных для печати
				color: setLowSwitch.color, // получаем цвет,
				index: this.state.changibleIndex
			};

			let pushedObj = {}
			if (this.state.changibleIndex === 0) {
				// Если вышестоящий конфигуратор, то селективность не рассчитываем
				pushedObj = {...newItem, selectivity: null}
				selectivityTable.splice(this.state.changibleIndex, 1, pushedObj)
				//если пересчитали вышестоящий конфигуратор пересчитываем все нижестоящие
				if (selectivityTable.length > 1) {
					selectivityTable.forEach((tableItem, index) => {
						if (index === 0) {
							return
						}

						const In = (+config.nominalCurrent / tableItem.fiveCol).toFixed(1);
						const Isd = (+config.releaseCurrent / tableItem.forCol).toFixed(1);

						if (In >= 2.5 && Isd >= 2) {
							tableItem.selectivity.In = In
							tableItem.selectivity.Isd = Isd
							tableItem.selectivity.provided1 = true
						} else {
							tableItem.selectivity.In = In
							tableItem.selectivity.Isd = Isd
							tableItem.selectivity.provided1 = false
						}
					})

				}
			} else {
				// Рассчитываем селективность
				const In = (+config.nominalCurrent / setLowSwitch.nominalCurrent).toFixed(1);
				const Isd = (+config.releaseCurrent / setLowSwitch.releaseCurrent).toFixed(1);
				// проверка на селективность
				if (In >= 2.5 && Isd >= 2) {
					pushedObj = {...newItem, selectivity: {In, Isd, provided1: true}}
				} else {
					pushedObj = {...newItem, selectivity: {In, Isd, provided1: false}}
				}
				selectivityTable.splice(this.state.changibleIndex, 1, pushedObj)
			}


		} else {

			// сохраняем настройки вышестоящего выклчателя
			let config = {};
			if (!this.highSwitcherChoosen()) {
				config = item;
			} else {
				if (!this.state.setLowSwitch.length) {
					config = this.state.setHighSwitch[0]
				} else {
					config = this.state.setLowSwitch[selectivityTable.length - 2];
				}

			}
			// получение нижестоящих выключателей
			const setLowSwitch = item;

			// проверка каждого выключателя на селективность
			const newItem = {
				firstCol: item.graphName, // Имя графика
				secondCol: setLowSwitch.name, // тип продукции
				threeCol: setLowSwitch.typeCurve, // тип кривой
				forCol: setLowSwitch.releaseCurrent, // ток расцепителя
				fiveCol: setLowSwitch.nominalCurrent,  // In номинальный ток
				info: item, // Сохраняем данные фильтра
				forPrint: this.getCurrentItem(item), // Сохранение данных для печати
				color: setLowSwitch.color, // получаем цвет,
				index: selectivityTable.length
			};

			if (!this.highSwitcherChoosen()) {
				// Если вышестоящий конфигуратор, то селективность не рассчитываем
				selectivityTable.push({...newItem, selectivity: null});
			} else {
				// Рассчитываем селективность
				const In = (+config.nominalCurrent / setLowSwitch.nominalCurrent).toFixed(1);
				const Isd = (+config.releaseCurrent / setLowSwitch.releaseCurrent).toFixed(1);
				// проверка на селективность
				if (In >= 2.5 && Isd >= 2) {
					selectivityTable.push({...newItem, selectivity: {provided1: true}});
				} else {
					selectivityTable.push({...newItem, selectivity: {In, Isd, provided1: false}});
				}
			}
		}
		this.setState({selectivityTable});
	}

	// Промежуточная подготовка данных
	getGraph(item) {
		let transferObj = []
		if (item.name !== '-') {
			// Получаем объек
			let dbItem = this.getCurrentItem(item)
			// Получаем графики
			let graph
			if (item.typeCurve === "Электронный") {
				graph = this.calculateElectronicRelease(item)
			} else {
				graph = this.getGraphPoints(item)
			}

			transferObj = [
				{
					data: graph[0],
					name: item.graphName,
					color: item.color,
					mark: item.typeCurve.trim() === 'Термомагнитный' ? 'модульный' : item.bodySize,
					current: item.nominalCurrent,
					outCurrent: String(item.breakingCapacity).length>2? item.breakingCapacity:item.breakingCapacity*1000,
					markSwitch: isNaN(item.Ii) && isNaN(item.Tr) && isNaN(item.Tsd)
				},
				{

					data: graph[1],
					name: item.graphName,
					color: item.color,
					mark: item.typeCurve.trim() === 'Термомагнитный' ? 'модульный' : item.bodySize,
					current: item.nominalCurrent,
					outCurrent: String(item.breakingCapacity).length>2? item.breakingCapacity:item.breakingCapacity*1000 ,
					markSwitch: isNaN(item.Ii) && isNaN(item.Tr) && isNaN(item.Tsd)
				},
			]
		} else {
			transferObj = [
				{
					data: item.graph,
					name: item.graphName,
					color: item.color,
					dashStyle: item.index ? item.index === 'engine' ? 'dot' : 'dash' : 'solid'
				},
			]

		}

		this.drowChart(transferObj, item.index)

	}

	//Метод определяет, выбран ли вышестоящий выключатель
	highSwitcherChoosen() {
		return this.state.setHighSwitch.length > 0
	}

	// Удалить дубли из массива
	delDuplicatesFromArray(array) {
		return array.filter(function (item, pos) {
			return array.indexOf(item) == pos
		});
	}

	// Обработка нажатия на строку
	onRowClick(item) {
		let timeout = 25
		let config = [...this.state.configurators.highSwitch]
		let configlow = [...this.state.configurators.lowSwitch]
		let itemInfo = item.info

		this.changeConfigurator('highSwitch', config[1], '', itemInfo.bodySize)
		setTimeout(() => {
			this.changeConfigurator('highSwitch', config[2], '', itemInfo.name)
		}, timeout * 2)
		setTimeout(() => {
			this.changeConfigurator('highSwitch', config[3], '', itemInfo.nominalCurrent)
		}, timeout * 3)
		setTimeout(() => {
			this.changeConfigurator('highSwitch', config[4], '', itemInfo.numberPoles)
		}, timeout * 4)
		setTimeout(() => {
			this.changeConfigurator('highSwitch', config[5], '', itemInfo.typeCurve)
		}, timeout * 5)
		setTimeout(() => {
			this.changeConfigurator('highSwitch', config[6], '', itemInfo.releaseCurrent)
		}, timeout * 6)
		setTimeout(() => {
			this.changeConfigurator('highSwitch', config[7], '', itemInfo.breakingCapacity)
		}, timeout * 7)
		if (itemInfo.typeCurve == "Электронный") {
			if (itemInfo.name.includes('MASTER')) {
				setTimeout(() => {
					this.changeConfigurator('lowSwitch', configlow[0], '', itemInfo.Ir)
				}, timeout * 8)
				setTimeout(() => {
					this.changeConfigurator('lowSwitch', configlow[1], '', itemInfo.Tr)
				}, timeout * 9)
				setTimeout(() => {
					this.changeConfigurator('lowSwitch', configlow[2], '', itemInfo.Isd)
				}, timeout * 10)
				setTimeout(() => {
					this.changeConfigurator('lowSwitch', configlow[3], '', itemInfo.Tsd)
				}, timeout * 11)
				setTimeout(() => {
					this.changeConfigurator('lowSwitch', configlow[4], '', itemInfo.Ii)
				}, timeout * 12)
			} else {
				setTimeout(() => {
					this.changeConfigurator('lowSwitch', configlow[0], '', itemInfo.Ir)
				}, timeout * 8)
				setTimeout(() => {
					this.changeConfigurator('lowSwitch', configlow[5], '', itemInfo.Im)
				}, timeout * 9)
				setTimeout(() => {
					this.changeConfigurator('lowSwitch', configlow[6], '', itemInfo.ICurve)
				}, timeout * 10)

			}
		}
		setTimeout(() => {
			this.setState({
				itemInfo: null
			});
		}, timeout * 8)

		this.addInfo(item.forPrint)

		this.setState({
			buttons: {
				button1: true,
				button2: false,
				button3: false,
				button4: false,
				button5: false,
			},
			changibleIndex: item.index
		});
	}

	//Получаем элемент из базы
	getCurrentItem(item) {
		let bodySize = item.bodySize === 'силовой' ? 'Литой корпус ' : item.bodySize
		let dbItem = []

		if (bodySize === 'Литой корпус ') {
			dbItem = this.db.list['selectivity'].filter(listItem => {
				return listItem.body_size === bodySize
					&& listItem.product_type === item.name
					&& +listItem.nominal_current === +item.nominalCurrent
					&& listItem.type_curve === item.typeCurve
					&& +listItem.power_Icu === +item.breakingCapacity
					&& listItem.power_Ics === item.maxBreakingCapacity
			})
		} else {
			dbItem = this.db.list['selectivity'].filter(listItem => {
				return listItem.body_size === bodySize
					&& listItem.product_type === item.name
					&& +listItem.nominal_current === +item.nominalCurrent
					&& +listItem.number_poles === +item.numberPoles
					&& listItem.type_curve === item.typeCurve
					&& +listItem.breaking_capacity === +item.breakingCapacity
			})
		}


		return dbItem[0]
	}

	// добавить элемент в информацию о товаре
	addInfo(item) {
		this.setState({itemInfo: null});
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'selectivity',
				action: 'getItemNSI',
				article: item.article
			},
			items => {
				this.setState((prevState) => {
					return {
						itemInfo: {
							...item,
							photo: (items[0] && items[0].ImgJpeg[0] && items[0].ImgJpeg[0].file_ref.uri) || '',
							description: items[0] && items[0].Description[0] && items[0].Description[0].desc_ru || '',
						}
					}
				})
			}
		);
	}

	//++служебные операции
	doPrint(params) {
		let _params = params || {};

		_params.data = {
			selectivityTable: JSON.stringify(this.state.selectivityTable),
			selectivitySC1: JSON.stringify(this.state.selectivitySC1),
			selectivitySC2: JSON.stringify(this.state.selectivitySC2)


		};

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	getCustomStyles() {
		return styles;
	}

	onSwitchConfigurator() {
		if (this.props.onSwitchConfigurator) {
			this.props.onSwitchConfigurator(this.state);
		}
	}

	//--служебные операции

	//чтение excel файла
	readExelFile(file) {
		const {files} = file.target;
		// Чтение файла через объект FileReader
		const fileReader = new FileReader()
		let data = [];
		fileReader.onload = event => {
			try {
				const {result} = event.target;
				// Читаем весь объект таблицы Excel в двоичном потоке
				const workbook = XLSX.read(result, {type: 'binary'});
				// сохранить полученные данные
				// проходим каждый лист для чтения (здесь по умолчанию читается только первый лист)
				for (const sheet in workbook.Sheets) {
					if (workbook.Sheets.hasOwnProperty(sheet)) {
						// Используем метод sheet_to_json для преобразования Excel в данные
						data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
						break; // Если берется только первая таблица, раскомментируйте эту строку
					}
				}
			} catch (e) {
				// Соответствующие запросы о неправильном типе ошибки файла могут быть брошены сюда
				alert('Неверный тип файла');
				return;
			}
			this.setState({data, fileName: files[0].name})
		}
		// Открыть файл в двоичном режиме
		fileReader.readAsBinaryString(files[0]);
	}

	// Получаем массив цветов
	getColorArray() {
		return ['red', 'yellow', 'green', 'blue', 'brown', 'black', 'teal', 'purple', 'deeppink',]
	}

	// Получаем массив координат, по которым строится график
	getGraphPoints(item) {
		let graph = []
		let graph_min = []
		let graph_max = []
		let graphData = this.db.list['selectivity_graph'].filter(dbItem => {
			return dbItem.product_type.toLowerCase().trim() === item.name.toLowerCase().trim()
				&& dbItem.nominal_current === item.nominalCurrent
				&& dbItem.type_curve.trim() === item.typeCurve.trim()
		})
		if (graphData[0]) {
			let y_points = graphData[0].y_points.split(';')
			let x_points_min = graphData[0].x_points_min.split(';')
			let x_points_max = graphData[0].x_points_max.split(';')
			y_points.forEach((y, id) => {
				let obj_min = {
					'x': isNaN(+x_points_min[id]) ? item.bodySize === 'силовой' ? item.breakingCapacity * 1000 : item.breakingCapacity : +x_points_min[id] * item.nominalCurrent,
					'y': +y
				}
				graph_min.push(obj_min)
				let obj_max = {
					'x': isNaN(+x_points_max[id]) ? item.bodySize === 'силовой' ? item.breakingCapacity * 1000 : item.breakingCapacity : +x_points_max[id] * item.nominalCurrent,
					'y': +y
				}
				graph_max.push(obj_max)
			})
		} else {
			let obj_min = {
				'x': 0,
				'y': 0
			}
			graph_min.push(obj_min)
			let obj_max = {
				'x': 0,
				'y': 0
			}
			graph_max.push(obj_max)
		}
		graph.push(graph_max, graph_min)
		return graph

	}

	//++ поиск точек пересечения графиков
	getLineIntersection(p0, p1, p2, p3) {
		let p0_x = p0.x;
		let p0_y = p0.y;
		let p1_x = p1.x;
		let p1_y = p1.y;
		let p2_x = p2.x;
		let p2_y = p2.y;
		let p3_x = p3.x;
		let p3_y = p3.y;


		let s1_x, s1_y, s2_x, s2_y;
		s1_x = p1_x - p0_x;
		s1_y = p1_y - p0_y;
		s2_x = p3_x - p2_x;
		s2_y = p3_y - p2_y;

		let s = (-s1_y * (p0_x - p2_x) + s1_x * (p0_y - p2_y)) / (-s2_x * s1_y + s1_x * s2_y);
		let t = (s2_x * (p0_y - p2_y) - s2_y * (p0_x - p2_x)) / (-s2_x * s1_y + s1_x * s2_y);
		if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
			return {x: p0_x + (t * s1_x), y: p0_y + (t * s1_y)};
		}

		return false;
	}

	getIntersectionPoints(graphPoints1, graphPoints2) {
		let s0 = graphPoints1
		let s1 = graphPoints2
		let s2 = []
		let isect;
		for (let i = 1; i < s0.length - 1; i++) {
			for (let j = 1; j < s1.length - 1; j++) {
				if (isect = this.getLineIntersection(s0[i - 1], s0[i], s1[j - 1], s1[j])) {
					s2.push(isect);
				}
			}
		}
		return s2
	}

	findPointsIntersections(data1, data2) {

		let point = this.getIntersectionPoints(data1, data2)
		return point
	}

	//-- поиск точек пересечения графиков

	//рассчет селективности
	calculateSelectivity(graph, current) {
		let selectivity = []
		graph.map((item, index, arr) => {
			if (index % 2 == 0) {
				return
			}
			if (arr[index + 1]) {
				if (item.data.length == 1 || arr[index + 1].data.length == 1) {
					selectivity.push(['Нет данных', '-'])
				} else {
					if (item.mark === arr[index + 1].mark && item.mark !== 'силовой') {
						if (item.mark === 'модульный') {
							if (item.data.every((elem, id) => {
								if (id == 14) {
									return true
								}
								return elem.x > arr[index + 1].data[id].x
							})) {
								if (current && item.data[item.data.length - 2].x > current.data[0].x && current.data[0].x > arr[index + 1].data[arr[index + 1].data.length - 2].x) {
									selectivity.push([`Полная селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2}`, '-'])
								} else {
									selectivity.push([`Частичная селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2}`, item.data[item.data.length - 2].x + ' A'])
								}
							} else {
								selectivity.push([`Селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2} не обеспечивается`, '-'])
							}
						} else if (item.mark === 'предохранитель') {
							if (item.current / arr[index + 1].current > 1.6) {
								selectivity.push([`Селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2} обеспечивается `, '-'])
							} else {
								selectivity.push([`Селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2} не обеспечивается`, '-'])
							}

						}

					} else {
						if (item.mark === 'предохранитель') {
							if (arr[index + 1].mark === 'силовой') {
								let point = this.findPointsIntersections(item.data, arr[index + 1].data)
								if (point.length == 1) {
									selectivity.push([`Частичная селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2}`, Math.round(point[0].x) + ' A'])
								} else {
									selectivity.push([`Селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2} не обеспечивается`, '-'])
								}
							} else {
								if (item.data.every((elem, id) => {
									if (id == 14) {
										return true
									}
									return elem.x > arr[index + 1].data[id].x
								})) {
									selectivity.push([`Частичная селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2}`, item.data[item.data.length - 2].x + ' A'])
								} else {
									selectivity.push([`Селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2} не обеспечивается`, '-'])
								}
							}
						} else {
							let point = this.findPointsIntersections(item.data, arr[index + 1].data)
							if (item.data.every((elem, id) => {
								if (id == 14) {
									return true
								}
								return elem.x > arr[index + 1].data[id].x
							})) {
								if (item.mark === 'силовой') {
									if (point.length == 0) {
										selectivity.push([`Селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2} обеспечивается `, '-'])
									} else {
										selectivity.push([`Селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2} не обеспечивается `, '-'])
									}
								} else {
									selectivity.push([`Селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2} обеспечивается `, '-'])
								}
							} else {
								selectivity.push([`Селективность между QF${selectivity.length + 1}-QF${selectivity.length + 2} не обеспечивается`, '-'])
							}
						}
					}
				}
			}

		})
		return selectivity

	}

	calculateElectronicRelease(item) {
		let graph = []
		let In = item.nominalCurrent
		let Ibc = item.breakingCapacity
		if (item.name.includes('MASTER')) {
			let Ir = item.Ir * In
			let Tr = item.Tr
			let Isd = item.Isd
			let Tsd = item.Tsd
			let Ii = isNaN(item.Ii) ? 15 * Ir : item.Ii * Ir
			let Im = Ir * Isd

			let point1 = isNaN(Tr) ? Math.pow(2 * Ir, 2) * 12 / Math.pow(Im, 2) : Math.pow(2 * Ir, 2) * Tr / Math.pow(Ir, 2)
			let point2 = isNaN(Tr) ? Math.pow(2 * Ir, 2) * 12 / Math.pow(Im, 2) : Math.pow(2 * Ir, 2) * Tr / Math.pow(Im, 2)
			let point3 = isNaN(Tsd) ? 0.06 : Math.pow(1.5 * Im, 2) * Tsd / Math.pow(Im, 2)
			let point4 = isNaN(Tsd) ? 0.06 : (Math.pow(1.5 * Im, 2) * Tsd / Math.pow(Ii, 2)) > 0.028 ? Math.pow(1.5 * Im, 2) * Tsd / Math.pow(Ii, 2) : 0.028
			let point5 = isNaN(item.Ii) ? point4 : 0.028

			let obj, obj_min, obj_max

			if (isNaN(Tr) && isNaN(Tsd) && isNaN(item.Ii)) {
				obj = [{'x': 1.05 * Ir, 'y': 7200},
					{'x': 1.05 * Ir, 'y': 3600},
					{'x': 1.05 * Ir, 'y': point1},
					{'x': 1.05 * Ir, 'y': point2},
					{'x': 1.05 * Ir, 'y': point3},
					{'x': 1.05 * Ir, 'y': point4},
					{'x': 1.05 * Ir, 'y': point5},
					{'x': 1.05 * Ir, 'y': point5},
					{'x': 1.05 * Ir, 'y': point5},
					{'x': 1.05 * Ir, 'y': point5},
					{'x': 1.05 * Ir, 'y': point5},
					{'x': 1.05 * Ir, 'y': point5},
					{'x': 1.05 * Ir, 'y': point5},
					{'x': 1.05 * Ir, 'y': point5},
					{'x': 1.05 * Ir, 'y': 0.00001}
				]
				obj_min = obj.map((item, index) => {
					return {'x': item.x * 0.9, 'y': item.y}
				})

				obj_max = obj.map((item, index) => {
					return {'x': item.x * 1.1, 'y': item.y}
				})
			} else {

				obj = [{'x': 1.05 * Ir, 'y': 7200},
					{'x': 1.05 * Ir, 'y': 3600},
					{'x': 1.05 * Ir, 'y': point1},
					{'x': Im, 'y': point2},
					{'x': Im, 'y': point3},
					{'x': Ii, 'y': point4},
					{'x': Ii, 'y': point5},
					{'x': Ii, 'y': point5},
					{'x': Ii, 'y': point5},
					{'x': Ii, 'y': point5},
					{'x': Ii, 'y': point5},
					{'x': Ii, 'y': point5},
					{'x': Ii, 'y': point5},
					{'x': 16 * In, 'y': point5},
					{'x': Ibc * 1000, 'y': point5}
				]

				obj_min = obj.map((item, index) => {
					if (index > 6) {
						return {'x': item.x, 'y': item.y}
					}
					if (index > 1 && !index == 6) {
						return {'x': item.x * 0.9, 'y': item.y * 0.9}
					}

					return {'x': item.x * 0.9, 'y': item.y}
				})

				obj_max = obj.map((item, index) => {
					if (index > 6) {
						return {'x': item.x, 'y': item.y}
					}
					if (index > 1 && !index == 6) {
						return {'x': item.x * 1.1, 'y': item.y * 1.1}
					}
					return {'x': item.x * 1.1, 'y': item.y}
				})
			}
			graph.push(obj_max, obj_min)
		} else {
			let Ir_min = item.Ir * In * 0.9
			let Ir_max = item.Ir * In * 1.1
			let Im_min = item.Im <= 2 ? item.Im * In * 0.9 : item.Im * In * 0.8
			let Im_max = item.Im <= 2 ? item.Im * In * 1.1 : item.Im * In * 1.2
			let curve = item.ICurve

			let point1_min = Math.pow(6 * Ir_min, 2) * curve * 0.8 / Math.pow(Ir_min, 2)
			let point1_max = Math.pow(6 * Ir_max, 2) * curve * 1.2 / Math.pow(Ir_max, 2)
			let point2_min = Math.pow(6 * Ir_min, 2) * curve * 0.8 / Math.pow(Im_min, 2)
			let point2_max = Math.pow(6 * Ir_max, 2) * curve * 1.2 / Math.pow(Im_max, 2)

			let obj_min = [{'x': Ir_min, 'y': 7200},
				{'x': Ir_min, 'y': 3600},
				{'x': Ir_min, 'y': point1_min},
				{'x': Im_min, 'y': point2_min},
				{'x': Im_min, 'y': 0.06},
				{'x': Im_min, 'y': 0.04},
				{'x': Im_min, 'y': 0.02},
				{'x': Im_min, 'y': 0.02},
				{'x': Im_min, 'y': 0.02},
				{'x': Im_min, 'y': 0.02},
				{'x': Im_min, 'y': 0.02},
				{'x': Im_min, 'y': 0.02},
				{'x': Im_min, 'y': 0.02},
				{'x': Im_min, 'y': 0.02},
				{'x': Ibc * 1000, 'y': 0.02}
			]
			let obj_max = [{'x': Ir_max, 'y': 7200},
				{'x': Ir_max, 'y': 3600},
				{'x': Ir_max, 'y': point1_max},
				{'x': Im_max, 'y': point2_max},
				{'x': Im_max, 'y': 0.06},
				{'x': Im_max, 'y': 0.04},
				{'x': Im_max, 'y': 0.02},
				{'x': Im_max, 'y': 0.02},
				{'x': Im_max, 'y': 0.02},
				{'x': Im_max, 'y': 0.02},
				{'x': Im_max, 'y': 0.02},
				{'x': Im_max, 'y': 0.02},
				{'x': Im_max, 'y': 0.02},
				{'x': Im_max, 'y': 0.02},
				{'x': Ibc * 1000, 'y': 0.02}
			]
			graph.push(obj_max, obj_min)
		}
		return graph
	}

	addOutCurrrentGraph(data) {
		let itemsGraph = []
		let i = 1
		let itemGraph

		data.forEach((item, index) => {
			if (index % 2 == 0) {
				return
			} else {
				if (item.mark === 'силовой' && item.markSwitch) {
					i++
					return;
				} else {
					let outCurrent = String(item.outCurrent).length < 3 ? item.outCurrent * 1000 : item.outCurrent
					itemsGraph.push({
						name: `Отключающая способность АЗ №${i}`,
						data: [{x: outCurrent, y: 10000}, {x: outCurrent, y: item.data[item.data.length - 1].y}],
						color: item.color,
						dashStyle: 'dashDot'
					})
				}
				i++
			}
		})
		return itemsGraph
	}


	//отрисовка графика
	drowChart(graphData, changibleIndex) {

		let graph = [{
			data: [],
			name: ''
		}]
		if (graphData) {
			if (changibleIndex !== undefined) {
				graph = [...this.state.graphs]
				if (isNaN(changibleIndex)) {
					if (changibleIndex === 'engine') {
						if (graph.some(i => i.name === `Пусковая характеристика двигателя`)) {
							graph.splice(graph.findIndex(i => i.name === `Пусковая характеристика двигателя`), 1, graphData[0])
						} else {
							graph = graph.concat(graphData)
						}
					} else {
						if (graph.some(i => i.name === `Ток короткого замыкания №${+changibleIndex[2]}`)) {
							graph.splice(graph.findIndex(i => i.name === `Ток короткого замыкания №${+changibleIndex[2]}`), 1, graphData[0])
						} else {
							graph = graph.concat(graphData)
						}
					}
				} else {
					graph.splice(2 * changibleIndex, 2, graphData[0], graphData[1])
				}
			} else {
				graph = [...this.state.graphs].concat(graphData)
			}

		}

		let data = graph.filter(item => item.name.includes('Аппарат защиты'))
		let currentSC = graph.filter(item => item.name.includes('Ток короткого замыкания'))
		let engine = graph.filter(item => item.name.includes('Пусковая'))

		let currentSC1 = graph.find((item) => item.name === 'Ток короткого замыкания №1')
		let selectivitySC1 = this.calculateSelectivity(data, currentSC1)

		let currentSC2 = graph.find((item) => item.name === 'Ток короткого замыкания №2')
		let selectivitySC2 = this.calculateSelectivity(data, currentSC2)
		let outCurrent = this.addOutCurrrentGraph(data)
		let breakingCapasityMin=0
			data.map((i,id,arr)=>{
				if(id==0){
					breakingCapasityMin=i.outCurrent
					return;
				}
				if( i.outCurrent<breakingCapasityMin){
					breakingCapasityMin=i.outCurrent
				} else {return}
			})
		if(currentSC1 && currentSC1.data[0].x>breakingCapasityMin){
			this.showWarning('Ток КЗ №1 превышает отключающую способность ВА, измените начальные условия.')
		}else if (currentSC2 && currentSC2.data[0].x>breakingCapasityMin){
			this.showWarning('Ток КЗ №2 превышает отключающую способность ВА, измените начальные условия.')
		}else if(currentSC1 && currentSC2 && currentSC1.data[0].x>breakingCapasityMin && currentSC2.data[0].x>breakingCapasityMin){
			this.showWarning('Токи КЗ №1 и КЗ №2 превышают отключающую способность ВА, измените начальные условия.')
		}



		graph = data.concat(currentSC, engine, outCurrent)
		this.setState({selectivitySC1, selectivitySC2})

		Highcharts.chart('containerChart', {
			title: {
				useHTML: false,
				text: ''
			},
			chart: {
				type: 'line',
				zoomType: 'xy',
			},

			xAxis: {
				title: {
					text: 'Ток, А',
					rotation: 0,
					margin: 1,
				},
				categories: [],
				type: 'logarithmic',
				minorTickInterval: 0.1,
				max: 100000,
				accessibility: {
					rangeDescription: 'Range: 0.1 to 100000'
				},
				gridLineWidth: 1,
			},
			colors: this.getColorArray(),
			yAxis: {
				title: {
					text: 'Время, с',
					rotation: 270,
					margin: 1,
				},
				type: 'logarithmic',
				minorTickInterval: 0.1,
				max: 10000,
				min: 0.001,
				accessibility: {
					rangeDescription: 'Range: 0.1 to 10000'
				},
				gridLineWidth: 0,
			},
			legend: {
				enabled: false
			},
			series: graph
		});


		if (graphData) {
			this.setState({
				graphs: graph
			})
		}
	}

	//контейнер для графика
	Chart() {
		return <div id='containerChart' style={{width: '643px', height: '400px'}}/>
	}

	// обработчик изменения конфигуратора
	changeConfigurator(type, item, options, defaultValue) {
		// изменение select
		let value;
		if (defaultValue == null) {
			for (let i = 0, l = options.length; i < l; i++) {
				options[i].selected
					? value = options[i].value
					: null
			}
		} else {
			value = defaultValue
		}

		const newItem = {...item, selected: value};

		let updateConfigurator = [...this.state.configurators[type]].map(i => i.name === newItem.name ? newItem : i);
		// подбор селекивного устойства для вышестоящего или нижестоящего
		//const selectBase = updateConfigurator[0].selected === 'вышестоящего' ? 'highSwitch' : 'lowSwitch';

		if (type === 'highSwitch') {
			let base;

			let bodySizeType = updateConfigurator[1].selected
			// поиск типа продукции в select
			if (updateConfigurator[0].selected !== null && updateConfigurator[1].selected !== null) {

				if (this.state.configurators[type][0].selected !== updateConfigurator[0].selected) {
					for (let i = 2; i < updateConfigurator.length; i++) {
						updateConfigurator[i].option = [];
						updateConfigurator[i].disabled = true;
						updateConfigurator[i].selected = null;
					}
				}

				// данные для фильтра по чекбоксам
				const checkbox1 = this.state.checkboxes.checkbox1;
				// фильтр
				//Сменить сделать выбор фильтра отдельный от базы данных

				bodySizeType = bodySizeType === 'силовой' ? "Литой корпус " : bodySizeType

				//ALESAN
				if (checkbox1) {
					base = this.db.list['selectivity']
						.filter(item => {
							return item.body_size === bodySizeType
						})

				} else {
					base = this.db.list['selectivity']
						.filter(item => {
							return item.body_size === bodySizeType &&
								item.out_of_production.toLowerCase().trim() === 'нет' // фильтр по показать снятые с производсва
						})

				}


				// фильтр по габариту корпуса
				// если перевыбран габарит корпуса обновить select
				if (this.state.configurators[type][1].selected !== updateConfigurator[1].selected) {
					for (let i = 2; i < updateConfigurator.length; i++) {
						if (i === 5) {
							if (bodySizeType === 'Литой корпус ') {
								updateConfigurator[i].name = 'Тип расцепителя'

							} else {
								updateConfigurator[i].name = 'Тип кривой срабатывания'
							}
						}
						updateConfigurator[i].option = [];
						updateConfigurator[i].disabled = true;
						updateConfigurator[i].selected = null;

						if (i === 7) {
							if (bodySizeType === 'Литой корпус ') {
								updateConfigurator[i].name = 'Рабочая отк-я способность (кА)'
							} else {
								updateConfigurator[i].name = 'Отключающая способность (кА)'
							}
						}

						if (i === 8) {
							if (bodySizeType === 'Литой корпус ') {
								updateConfigurator[i].show = true
							} else {
								updateConfigurator[i].show = false
							}
						}
					}
					this.setState(prev => {
						return {
							itemInfo: null,
						}
					});

				}
				let productTypesArray = base.map(item => item.product_type)
				// ALESAN
				// Подставлять из базы данных уникальные типы продукции
				updateConfigurator[2].option = this.delDuplicatesFromArray(productTypesArray)
				updateConfigurator[2].disabled = false;

				// если перевыбран тип продукции обновить select
				if (this.state.configurators[type][2].selected !== updateConfigurator[2].selected) {
					for (let i = 3; i < updateConfigurator.length; i++) {
						updateConfigurator[i].option = [];
						updateConfigurator[i].disabled = true;
						updateConfigurator[i].selected = null;
					}
				}
			}

			// поиск всех дополнительных данных в select
			if (updateConfigurator[2].selected !== null) {
				const options = base.filter(i => {
					return i.product_type === updateConfigurator[2].selected ? i : null
				})

				let currentNominal = options.map(item => {
					return item.nominal_current
				})
				// добавление номинального тока
				// ALESAN
				// Подставлять из базы данных уникальные номиналы тока исходя из того какой выбран тип продукции
				updateConfigurator[3].option = this.delDuplicatesFromArray(currentNominal)
				updateConfigurator[3].disabled = false
				if (updateConfigurator[3].selected !== null) {
					//Если выбран "силовой" тип корпуса, ставим 3 полюса без возможности изменения (согласно ТЗ)
					if (updateConfigurator[1].selected !== null && bodySizeType === 'Литой корпус ') {
						updateConfigurator[4].option = [3]
						updateConfigurator[4].selected = 3
						updateConfigurator[4].disabled = true
					} else {
						// ALESAN
						// Подставлять из базы данных уникальное число полюсов исходя из того какой выбран тип продукции
						let numPolesArray = options.map(item => item.number_poles)
						updateConfigurator[4].option = this.delDuplicatesFromArray(numPolesArray)
						updateConfigurator[4].disabled = false
						if (updateConfigurator[4].selected == null) {
							updateConfigurator[4].selected = numPolesArray[0]
						}
					}
				}

				if (updateConfigurator[4].selected !== null) {
					// ALESAN
					// Подставлять из базы данных уникальное типы расцепителя или типы кривой
					// исходя из того какой выбран тип продукции и габарит корпуса
					let curveType = base.filter(i => i.product_type === updateConfigurator[2].selected).map(i => i.type_curve)
					updateConfigurator[5].option = this.delDuplicatesFromArray(curveType)
					updateConfigurator[5].disabled = false
				}


				if (updateConfigurator[5].selected !== null) {
					if (bodySizeType === 'Литой корпус ') {
						let nomCurrArray = options.map(item => item.nominal_current)
						// ALESAN
						// Подставлять из базы данных уникальное значение наминального тока или несколько полей для ввода
						// исходя из того какой выбран тип продукции и значеня типа расчцепителя
						updateConfigurator[6].option = [updateConfigurator[3].selected * 10]
						if (updateConfigurator[6].selected == null) {
							updateConfigurator[6].selected = updateConfigurator[3].selected * 10
						}
					} else {
						// Если выбран мобудльный тип корпуса, номинальный ток считается по формуле, зависящей от типа кривой
						let mult = 1
						switch (updateConfigurator[5].selected) {
							case 'B':
								mult = 5;
								break;
							case 'C':
								mult = 10;
								break;
							case 'D':
								mult = 20;
								break;
							default:
								mult = 1;
						}
						let arr = []
						arr.push(mult * updateConfigurator[3].selected)
						updateConfigurator[6].option = arr
						updateConfigurator[6].selected = mult * updateConfigurator[3].selected
						updateConfigurator[6].disabled = false
					}


					let itemInfo = {
						'bodySize': updateConfigurator[1].selected,
						'name': updateConfigurator[2].selected,
						'nominalCurrent': updateConfigurator[3].selected,
						'numberPoles': updateConfigurator[4].selected,
						'typeCurve': updateConfigurator[5].selected,
						'breakingCapacity': updateConfigurator[7].selected,
						'maxBreakingCapacity': updateConfigurator[8].selected
					}

					let dbItem = this.getCurrentItem(itemInfo)
					this.addInfo(dbItem)
				}
				let brCapArray = []
				// отключающая способность
				if (bodySizeType === 'Литой корпус ') {
					brCapArray = options.map(item => item.power_Icu)
				} else {
					brCapArray = options.map(item => item.breaking_capacity)
				}

				// ALESAN
				// Подставлять из базы данных уникальное значение наминального тока или несколько полей для ввода
				// исходя из того какой выбран тип продукции и значеня типа расчцепителя
				updateConfigurator[7].option = this.delDuplicatesFromArray(brCapArray)

				if (bodySizeType === 'Литой корпус ') {
					updateConfigurator[7].disabled = true
				} else {
					updateConfigurator[7].disabled = false
				}
				if (updateConfigurator[7].selected === null) {
					updateConfigurator[7].selected = brCapArray[0]
				}

				if (bodySizeType === 'Литой корпус ') {
					let maxBrCapArray = options.map(item => item.power_Ics)
					updateConfigurator[8].option = this.delDuplicatesFromArray(maxBrCapArray)
					updateConfigurator[8].selected = maxBrCapArray[0]
				} else {
					updateConfigurator[8].option = []
					updateConfigurator[8].selected = null
				}
			}
		} else {
			if (updateConfigurator[0].selected !== null) {

				if (this.state.configurators[type][0].selected !== updateConfigurator[0].selected) {
					for (let i = 1; i < updateConfigurator.length - 2; i++) {
						updateConfigurator[i].disabled = true;
						updateConfigurator[i].selected = null;
					}
				}
				updateConfigurator[1].disabled = false
				if (updateConfigurator[1].selected !== null) {
					if (this.state.configurators[type][1].selected !== updateConfigurator[1].selected) {
						for (let i = 2; i < updateConfigurator.length - 2; i++) {
							updateConfigurator[i].disabled = true;
							updateConfigurator[i].selected = null;
						}
					}
					updateConfigurator[2].disabled = false
					if (updateConfigurator[2].selected !== null) {
						if (this.state.configurators[type][2].selected !== updateConfigurator[2].selected) {
							for (let i = 3; i < updateConfigurator.length - 2; i++) {
								updateConfigurator[i].disabled = true;
								updateConfigurator[i].selected = null;
							}
						}
						updateConfigurator[3].disabled = false
						if (updateConfigurator[3].selected !== null) {
							updateConfigurator[4].disabled = false
						}
					}
				} else if (updateConfigurator[5].selected !== null) {
					if (this.state.configurators[type][5].selected !== updateConfigurator[5].selected) {
						updateConfigurator[6].disabled = true;
						updateConfigurator[6].selected = null;
					}
					updateConfigurator[6].disabled = false
				}

			}
		}


		// обновление конфигуратора
		return this.setState(prev => {
			return {
				configurators: {...prev.configurators, [type]: updateConfigurator}
			}
		})

	}

	//введение время-токовой характеристики вручную
	readManualPoints(e, id, mark) {
		const value = e === '' ? '' : e.target.value;
		if (this.state.data.length - id > 0) {
			this.setState(prev => {
					let data = [...prev.data]
					data[id][mark] = +value
					return {
						data
					}
				}
			)
		} else {
			this.setState(prev => {
					let data = [...prev.data]
					let obj = {}
					if (mark === 'Время, с.') {
						obj = {[mark]: +value, 'Ток, А.': 0}
					} else {
						obj = {'Время, с.': 0, [mark]: +value}
					}
					data.push(obj)
					return {data}
				}
			)

		}
	}

	//подготовка данных токов короткого замыкания для граффика
	onLoadGraphDataCurrentKZ(e, id) {
		//Формирование имени графика
		const value = e === '' ? '' : e.target.value;
		let graphName = 'Ток короткого замыкания №' + id
		let graph = [{y: 10000, x: +value}, {y: 0.0001, x: +value}]
		let color = ['purple', 'deeppink']

		// запись всех полей
		const addSwitch = {
			name: '-', // тип проду	кции
			graphName: graphName, // имя графика
			color: color[id - 1], // цвет графика
			graph: graph,
			index: `KZ${id}`
		};

		this.getGraph(addSwitch)
	}

	//чтение данных пусковой характеристики двигателя
	readEngineData(e, group, mark) {
		const value = e === '' ? '' : e.target.value;
		let engine = this.state.engine
		let obj = {}
		let obj_fin = {}
		if (mark === 'time') {
			obj = {y: +value, x: engine[group].x}
			if (group === 2) {
				let obj = {y: +value, x: engine[group + 1].x}
				engine.splice(group + 1, 1, obj)
			}
		} else {
			obj = {y: engine[group].y, x: +value}
			if (group === 3) {
				obj_fin = {y: 7200, x: +value}
				engine.splice(engine.length - 1, 1, obj_fin)
			}
		}
		engine.splice(group, 1, obj)
		this.setState({engine})
	}

	//подготовка данных пусковой характеристики двигателя для граффика
	onLoadGraphDataEngine() {
		const addSwitch = {
			name: '-', // тип проду	кции
			graphName: 'Пусковая характеристика двигателя', // имя графика
			color: 'black', // цвет графика
			graph: this.state.engine,
			index: `engine`
		};

		this.getGraph(addSwitch)
	}

	//очистка полей пусковой характеристики двигателя
	clearEngineData() {
		let engine = [{y: 0.0001, x: 0.0001}, {y: 0, x: 0}, {y: 0, x: 0}, {y: 0, x: 0}, {y: 7200, x: 0}]
		let graph = [...this.state.graphs]
		if (graph.some(i => i.name === `Пусковая характеристика двигателя`)) {
			graph.splice(graph.findIndex(i => i.name === `Пусковая характеристика двигателя`), 1)
		}
		document.getElementsByName('engineInput').forEach(i => i.value = '')
		this.setState({engine, graphs: graph}, () => this.drowChart([]))
	}


	// Конфигуратор
	SwitchConfigurator(title, type = 'default', options) {
		const customStyles = this.getCustomStyles()
		const numberSwitch = type === 'highSwitch' ? ' № ' + (this.state.changibleIndex !== null ? this.state.changibleIndex + 1 : this.state.selectivityTable.length === 5 ? 5 : this.state.selectivityTable.length + 1) : null
		const optionsAdd = this.state.configurators.lowSwitch
		const configurator = [...this.state.configurators.highSwitch];
		const configuratorLow = [...this.state.configurators.lowSwitch]
		let point1
		let point2
		if (this.state.buttons.button5 && this.state.configurators.lowSwitch[3].selected !== null && this.state.configurators.lowSwitch[1].selected !== null && this.state.configurators.lowSwitch[4].selected !== null) {
			let Ir = configuratorLow[0].selected * configurator[3].selected
			let Tr = configuratorLow[1].selected
			let Isd = configuratorLow[2].selected
			let Tsd = configuratorLow[3].selected
			let Ii = isNaN(configuratorLow[4].selected) ? 15 * Ir : configuratorLow[4].selected * Ir
			let Im = Ir * Isd
			point1 = isNaN(Tr) ? Math.pow(2 * Ir, 2) * 12 / Math.pow(Im, 2) : Math.pow(2 * Ir, 2) * Tr / Math.pow(Im, 2)
			point2 = isNaN(Tsd) ? 0.06 : Math.pow(1.5 * Im, 2) * Tsd / Math.pow(Im, 2)
		}
		return <div>
			<h2 className={customStyles.subTitleSwitch}>{title} {numberSwitch}</h2>
			{(this.state.buttons.button1 || this.state.buttons.button2) &&
				<div className={customStyles.resetFilter} onClick={this.onResetFilter}/>
			}
			{this.state.buttons.button1 && !this.state.buttons.button5 &&
				<React.Fragment>
					<div className={customStyles.optionBlocks}>
						<label>Показывать снятые с производства:</label>
						<input type="checkbox" checked={this.state.checkboxes.checkbox1} onChange={() => this.ChangeCheckbox()}/>
					</div>
					{options.map((item, index) => {
						if (item.show) {
							return (
								<div className={customStyles.optionBlock} key={index}>
									<span>{item.name}:</span>
									<select
										value={item.selected === null ? 'выбрать' : item.selected}
										disabled={item.disabled}
										onChange={e => this.changeConfigurator(type, item, e.target.options, null)}
									>
										{item.selected === null && <option value="выбрать">выбрать</option>}

										{item.option.map((option, index) => {
											return (
												<option value={option} key={index}>{option}</option>
											)
										})}
									</select>
								</div>
							)
						}
					})}
				</React.Fragment>
			}
			{this.state.configurators.highSwitch[5].selected === 'Электронный' && this.state.buttons.button5 &&
				<React.Fragment>
					{optionsAdd.map((item, index) => {
						if (index >= 1 && !this.state.configurators.highSwitch[2].selected.includes('MASTER') ? !item.show : item.show) {
							return (
								<div className={customStyles.optionBlock} key={index}>
									<span>{item.name}:</span>
									<select
										style={{width: '83px'}}
										value={item.selected === null ? 'выбрать' : item.selected}
										disabled={item.disabled}
										onChange={e => this.changeConfigurator('lowSwitch', item, e.target.options, null)}
									>
										{item.selected === null && <option value="выбрать">выбрать</option>}

										{item.option.map((option, index) => {
											return (
												<option value={option} key={index}>{option}</option>
											)
										})}
									</select>

								</div>
							)
						}
					})}
					{this.state.configurators.lowSwitch[4].selected !== null && this.state.configurators.lowSwitch[2].selected !== null && +this.state.configurators.lowSwitch[4].selected < +this.state.configurators.lowSwitch[2].selected &&
						<div style={{fontSize: '16px', color: 'red', paddingTop: '15px'}}>Внимание! Должно вылоняться условие:
							Ii>Isd. Для
							продолжения исправьте
							параметры.</div>}
					{point2 > point1 &&
						<div style={{fontSize: '16px', color: 'red', paddingTop: '15px'}}>Внимание! Должно выполняться условие:
							расчетное время Tsd(t3)>Tr(t2). Для продолжения исправьте параметры.</div>

					}
				</React.Fragment>
			}
		</div>
	}


	render() {
		const customStyles = this.getCustomStyles()

		return (

			<div className={customStyles.cfg}>

				{this.getCustomElements ? this.getCustomElements() : null}

				{this.state.warningText && <Popup
					warningText={this.state.warningText}
					onClick={this.closeWarning}
				/>}
				{/*Белый фон и лого*/}
				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '14%', height: '80px'}}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Желтый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#ffc93a', width: '100%', height: '80px'}}/>
				<div className={styles.title}>Калькулятор токовой селективности аппаратов защиты от сверхтоков IEK</div>

				{/* Чекбоксы для фильтра */}

				{/*/!* Выбор выкюлчателя *!/*/}

				<div className={customStyles.highSwitch}>
					{this.SwitchConfigurator('АППАРАТ ЗАЩИТЫ', 'highSwitch', this.state.configurators.highSwitch)}
				</div>
				{!this.state.buttons.button1 && !this.state.buttons.button3 && (this.state.selectivityTable.length === 5 ?
					<span className={customStyles.empty}>Вы ввели максимальное количество аппаратов защиты</span> :
					<span className={customStyles.empty}>Вводите сначала вышестоящие аппараты защиты, а затем нижестоящие</span>)
				}
				{this.state.buttons.button3 &&

					<div className={this.state.data.length > 9 ? styles.inputAllConteinerScroll : styles.inputAllConteiner}>
						<div className={styles.inputConteiner}>
							<span className={styles.inputList}>Время, с</span>
							<span className={styles.inputList}>Ток, А</span>
						</div>
						<div className={styles.inputConteiner}>
							<input className={styles.inputList} type="number" min={0} defaultValue={0}
										 onChange={e => this.readManualPoints(e, 0, 'Время, с.')}/>
							<input className={styles.inputList} type="number" min={0} defaultValue={0}
										 onChange={e => this.readManualPoints(e, 0, 'Ток, А.')}/>
						</div>
						{this.state.data.map((i, id) => {
								return (
									<div className={styles.inputConteiner}>
										<input className={styles.inputList} type="number" min={0} defaultValue={0}
													 onChange={e => this.readManualPoints(e, id + 1, 'Время, с.')}/>
										<input className={styles.inputList} type="number" min={0} defaultValue={0}
													 onChange={e => this.readManualPoints(e, id + 1, 'Ток, А.')}/>
									</div>
								)
							}
						)
						}
					</div>


				}
				{this.state.buttons.button4 &&
					<React.Fragment>
						<label for="file-upload" className={styles.inputLoadGraphDataLabel}>
							<div className={styles.inputLoadGraphDataLabelIcon}></div>
							<div className={styles.mainBtnTextBig}>{this.state.fileName}</div>
						</label>
						<input id="file-upload" className={styles.inputLoadGraphData} type="file" accept='.xlsx, .xls'
									 onChange={this.readExelFile}/>
						<div className={styles.sampleExcel} onClick={this.onXLSDownload}>Скачать шаблон для заполнения</div>
					</React.Fragment>
				}


				{/*Заголовко "Описание"*/}
				<div className={customStyles.descriptionTitle}>
					<h2 className={customStyles.subTitleSwitch}>ОПИСАНИЕ</h2>
				</div>
				{/* Описание */}
				{this.state.itemInfo && this.state.itemInfo.description ? (
					<div className={styles.description}>{this.state.itemInfo.description}</div>
				) : (
					<div className={styles.descriptionEmpty}/>
				)}
				{this.state.buttons.button1 &&
					<span id='selWarn' className={styles.selectivityWarningEnable}>* - заполните все поля</span>
				}
				{/* Изображение */}
				<div
					className={styles.img}
					style={this.state.itemInfo && this.state.itemInfo.photo ?
						{backgroundImage: `url(${this.state.itemInfo.photo})`, backgroundSize: 'contain'}
						: null
					}
				/>


				{/* Таблица селектвности */}
				<div className={customStyles.selectivity}>
					<table className={customStyles.selectivityTable}>
						<thead>
						<tr>
							<th style={{width: '100px'}}>Имя графика</th>
							<th style={{width: '80px'}}>Тип продукции</th>
							<th style={{width: '100px'}}>Тип кривой/ Тип расцепителя</th>
							<th style={{width: '100px'}}>Установка мгновенного срабатывания</th>
							<th style={{width: '100px'}}>I<sub>n</sub></th>
							<th style={{width: '185px'}}>Вывод по I<sub>кз1</sub></th>
							<th style={{width: '185px'}}>Вывод по I<sub>кз2</sub></th>
							<th style={{width: '150px'}}>Предельный ток селективности
								<tr>
									<th style={{width: '75px'}}>I<sub>кз1</sub></th>
									<th style={{width: '75px'}}>I<sub>кз2</sub></th>
								</tr></th>
						</tr>
						</thead>
						{this.selectivityTable(this.state.selectivityTable)}
					</table>
				</div>

				<h2 className={customStyles.subTitleKZ}>Учёт токов короткого замыкания</h2>
				<div className={customStyles.choiceKZ}>
					<div className={customStyles.choiceKZItem}>
						<div>Ток короткого замыкания I<sub>кз1</sub>, А</div>
						<input type="number" min={0} style={{width: "70px", height: '26px'}}
									 onChange={e => this.onLoadGraphDataCurrentKZ(e, 1)}/></div>
					<div className={customStyles.choiceKZItem}>
						<div>Ток короткого замыкания I<sub>кз2</sub>, А</div>
						<input type="number" min={0} style={{width: "70px", height: '26px'}}
									 onChange={e => this.onLoadGraphDataCurrentKZ(e, 2)}/>
					</div>
				</div>

				<h2 className={customStyles.subTitleKZ} style={{top: "570px"}}>Пусковая характериcтика двигателя</h2>
				<div className={customStyles.choiceKZ} style={{top: "620px"}}>
					<div className={customStyles.choiceKZItem}>
						<div>Номинальный рабочий ток, А</div>
						<input type="number" min={0} name={'engineInput'} style={{width: "70px", height: '26px'}}
									 onChange={e => this.readEngineData(e, 3, 'current')}/></div>
					<div className={customStyles.choiceKZItem}>
						<div>Пусковой ток, А</div>
						<input type="number" min={0} name={'engineInput'} style={{width: "70px", height: '26px'}}
									 onChange={e => this.readEngineData(e, 2, 'current')}/>
					</div>
					<div className={customStyles.choiceKZItem}>
						<div>Продолжительность пускового тока, с</div>
						<input type="number" min={0} name={'engineInput'} style={{width: "70px", height: '26px'}}
									 onChange={e => this.readEngineData(e, 2, 'time')}/></div>
					<div className={customStyles.choiceKZItem}>
						<div>Ударно-пусковой ток, А</div>
						<input type="number" min={0} name={'engineInput'} style={{width: "70px", height: '26px'}}
									 onChange={e => this.readEngineData(e, 1, 'current')}/>
					</div>
					<div className={customStyles.choiceKZItem}>
						<div>Продолжительность ударно-пускового тока, с</div>
						<input type="number" min={0} name={'engineInput'} style={{width: "70px", height: '26px'}}
									 onChange={e => this.readEngineData(e, 1, 'time')}/></div>
				</div>


				{/*график*/}
				<div className={customStyles.Chart}>
					{this.Chart()}
				</div>

				{/* Подобрать устройство по селективности*/}

				{/* Техническая поддержка */}
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '1238px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '22px',
					top: '1238px',
					left: '512px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '1242px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>

			</div>

		);
	}
}

export default SelectivityConfigurator;




// WEBPACK FOOTER //
// ./src/react/SelectivityConfigurator.jsx